import { render } from "./PollAnswers.vue?vue&type=template&id=4597bfff"
import script from "./PollAnswers.vue?vue&type=script&lang=js"
export * from "./PollAnswers.vue?vue&type=script&lang=js"

import "./PollAnswers.vue?vue&type=style&index=0&id=4597bfff&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__